import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ru } from "date-fns/locale/ru";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { Toaster } from "react-hot-toast";

import { store } from "./business.InterfaceLayer/store";
import mainRouter, { fullRouter } from "./user.InterfaceLayer/router";
import ToasterModalWindow from "./user.InterfaceLayer/Components/generalComponents/ModalWindows/Toaster.modalWindow";
import { ConfirmProvider } from "material-ui-confirm";

import "./user.InterfaceLayer/styles/default.style.css";
import "./user.InterfaceLayer/styles/global.style.css";
import "./user.InterfaceLayer/styles/scrollbar.style.css";

// import "@fontsource/roboto/300.css";
// import "@fontsource/roboto/400.css";
// import "@fontsource/roboto/500.css";
// import "@fontsource/roboto/700.css";
import "../src/18n";
import {
	darkStyles,
	lightStyles,
} from "./user.InterfaceLayer/styles/theme.style";
import toastStyle from "./user.InterfaceLayer/styles/toast.style";
import ThemeProvider from "./user.InterfaceLayer/Components/generalComponents/ThemeProvider";

const element = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(element);
const routers = createBrowserRouter(fullRouter);

// центральный router
root.render(
	<LocalizationProvider
		dateAdapter={AdapterDateFns}
		adapterLocale={ru}
	>
		<ConfirmProvider>
			<Provider store={store}>
				<ThemeProvider
					darkStyles={darkStyles}
					lightStyles={lightStyles}
				>
					<>
						<RouterProvider router={routers} />
						<ToasterModalWindow>
							<Toaster
								position={"bottom-left"}
								reverseOrder={false}
								toastOptions={toastStyle}
							/>
						</ToasterModalWindow>
					</>
				</ThemeProvider>
			</Provider>
		</ConfirmProvider>
	</LocalizationProvider>
);
